import { Component, OnInit, Output, EventEmitter, Input, ViewChild, QueryList } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'modal-download',
    templateUrl: '../../templates/partials/modal-download.html'
})

export class ModalDownloadComponent implements OnInit {

    @Input() showModal;
    @Input() data;
    @Output() emitCloseModal = new EventEmitter();
    public billNumber: string;
    public enableButton: boolean = false;
    @ViewChild('downloadModal') public billModal:ModalDirective;
    constructor() { }

    public onHidden():void {
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public closeModal():void{
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public downloadBill():void {
        this.enableButton = false;
        this.emitCloseModal.emit({action:"close", data: this.billNumber});
    }

    public enableButtonDownload(event): void {
        this.enableButton = (this.billNumber.length > 4) ? true : false;
    }

    ngOnChanges(changes: any) {
        (this.showModal) ? this.billModal.show() : this.billModal.hide();
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/dummy/modal-download.component.ts